import { ReactNode, FC } from 'react';

interface FormFieldWrapperProps {
  children: ReactNode;
  className?: string;
}

/**
 * FormFieldWrapper component to ensure consistent wrapping and styling
 * for form fields in flex layouts.
 */
const FormFieldWrapper: FC<FormFieldWrapperProps> = ({ children, className = '' }) => {
  return (
    <div className={`form-input ${className}`}>
      {children}
    </div>
  );
};

export default FormFieldWrapper;
